







import { Component, Vue } from 'vue-property-decorator'
import CategoryList from '@/components/category/CategoryList.vue'

@Component({
  components: {
    CategoryList
  }
})
export default class Category extends Vue {}
